import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgListView = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 23,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		stroke: "#2B2B2B",
		fill: "none",
		fillRule: "evenodd",
		children: [
			/* @__PURE__ */ _jsx("rect", {
				x: 8.5,
				y: .5,
				width: 15,
				height: 3.792,
				rx: 1
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 8.5,
				y: 6.25,
				width: 15,
				height: 3.792,
				rx: 1
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: .5,
				y: .5,
				width: 4,
				height: 3.792,
				rx: 1
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 8.5,
				y: 12,
				width: 15,
				height: 3.792,
				rx: 1
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: .5,
				y: 12,
				width: 4,
				height: 3.792,
				rx: 1
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 8.5,
				y: 17.75,
				width: 15,
				height: 3.792,
				rx: 1
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: .5,
				y: 17.75,
				width: 4,
				height: 3.792,
				rx: 1
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: .5,
				y: 6.25,
				width: 4,
				height: 3.792,
				rx: 1
			})
		]
	})
});
export default SvgListView;
